import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.scss?vue&type=style&index=0&id=adaf2b74&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adaf2b74"]])

export default __exports__